import {
	Component,
	OnInit,
	ViewChildren,
	ViewChild,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	ViewRef,
	HostListener,
	Optional,
	Inject
}
	from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import moment from 'moment';
// Material
import { MatDialog, MatDialogRef, MatTabChangeEvent, MAT_DIALOG_DATA } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
// RXJS
import { ReplaySubject, BehaviorSubject, Subject } from 'rxjs';
//Service
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { KhoChuyenKhoPageService } from '../kho-chuyen-kho-page-service/kho-chuyen-kho-page.service';
//Model
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { ChuyenKhoNoiBoMaster, ChuyenKhoNoiBoDetail } from '../kho-chuyen-kho-page-model/kho-chuyen-kho-page.model';
//Component
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DeNghiChuyenKhoService } from '../../../chuc-nang-kho/de-nghi-chuyen-kho/de-nghi-chuyen-kho-service/de-nghi-chuyen-kho.service';
import { DeNghiChuyenKhoDialogDetailComponent } from '../../../chuc-nang-kho/de-nghi-chuyen-kho/de-nghi-chuyen-kho-dialog-detail/de-nghi-chuyen-kho-dialog-detail.component';
@Component({
	selector: 'm-kho-chuyen-kho-detail-page',
	templateUrl: './kho-chuyen-kho-detail-page.component.html',
	styleUrls: ['../kho-chuyen-kho-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})
export class KhoChuyenKhoPageDetailComponent implements OnInit {
	/* Các trường focus cho các tag trong form */
	@ViewChild(CdkVirtualScrollViewport, { static: false }) cdkVirtualScrollViewPort: CdkVirtualScrollViewport;
	@ViewChildren('focusDetail') focusDetail;
	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/
	/*--------------------Comment columns mat-table----------------------*/
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'MaHH',
			displayName: 'Mã hàng - tên hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'TenKhoChuyen',
			displayName: 'Kho chuyển',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'ViTriKhoChuyen',
			displayName: 'Vị trí chuyển',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'SoLo',
			displayName: 'Lot - số máy',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'SoLuongChuyenQuiDoi',
			displayName: 'Số lượng chuyển',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'SoLuongNhanQuiDoi',
			displayName: 'Số lượng nhận',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'TenKhoNhan',
			displayName: 'Kho nhận',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'ViTriKhoNhan',
			displayName: 'Vị trí nhận',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'PalletChuyen',
			displayName: 'Pallet Chuyển',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 11,
			name: 'PalletNhan',
			displayName: 'Pallet Nhận',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'SoMay',
			displayName: 'Số máy',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'SoMeSoXe',
			displayName: 'Số mẻ/Số xe',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'MaThung',
			displayName: 'Mã thùng (TP)',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'NgayDongThung',
			displayName: 'Ngày đóng thùng',
			alwaysChecked: false,
			isShow: true
		},

		{
			stt: 9,
			name: 'GhiChu',
			displayName: 'Ghi chú',
			alwaysChecked: false,
			isShow: true
		}
	];
	/* ------------------------------------------------------------------*/
	/* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */
	/* ------------------------------Selection ---------------------------*/
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<ChuyenKhoNoiBoDetail>(true, []);
	/* ------------------------------------------------------------------ */
	/* ------------------- Các form trên dialog --------------------------*/
	masterForm: FormGroup;
	/* ------------------------------------------------------------------ */
	/*---------------------- Thông tin thao tác cho phiếu --------------- */
	masterItem: ChuyenKhoNoiBoMaster;
	listDetail: ChuyenKhoNoiBoDetail[] = [];
	tmpListDetail: ChuyenKhoNoiBoDetail[] = [];
	/* ------------------------------------------------------------------ */
	/*------------------------- Extend field: ----------------------------*/
	title: string = '';
	previousIndex: number;
	fixedPoint = 2;
	isChange: boolean = false;
	viewLoading: boolean = false;
	disableNewButton: boolean = true;
	openTimKiemNangCao = false;
	keywordChanged: Subject<string> = new Subject<string>();
	loadingMerchandise = new BehaviorSubject<boolean>(false);
	fakeOptionNumber: number = 5;
	detailIdInfo = 0;
	/* ------------------------------------------------------------------ */
	constructor(
		@Optional() public dialogRef: MatDialogRef<KhoChuyenKhoPageDetailComponent>,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
		private service: KhoChuyenKhoPageService,
		private formBuilder: FormBuilder,
		public dialog: MatDialog,
		private router: Router,
		private datePipe: DatePipe,
		private subheaderService: SubheaderService,
		private activatedRoute: ActivatedRoute,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private dungChungService: DungChungService,
		private deNghiChuyenKhoService: DeNghiChuyenKhoService,
	) { }
	/*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.masterItem = new ChuyenKhoNoiBoMaster();
		this.masterItem.clear();
		this.createForm();
		let breadcrumbs = [{ title: 'Kho' }, { title: 'Phiếu chuyển kho', page: '/chuyen-kho' }, { title: 'Chi tiết phiếu chuyển kho' }];
		this.subheaderService.setBreadcrumbs(breadcrumbs);
		this.title = this.getTitle();
		this.activatedRoute.params.subscribe(params => {
			this.detailIdInfo = +params.id;
		});
		if (this.data && this.data.id) this.detailIdInfo = this.data.id;
		if (this.detailIdInfo && this.detailIdInfo > 0) {
			this.masterItem.IdCk = this.detailIdInfo;
			this.service.getItemById(this.detailIdInfo).subscribe(res => {
				if (res.status == 1) {
					this.masterItem = res.data
					if (this.masterForm != null) {
						this.bindingValueAfterCallAPIDetail();
					}
				}
			});
		}
		this.showColumnsInTable();
		this.applySelectedColumns();
	}
	/* -----------------------------------------------------------------------*/
	/*----------------- Create Form with appropriate sub forms ---------------*/
	createForm() {
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
		/*Group các Form */
		this.masterForm = this.formBuilder.group({
			SoPhieu: [''],
			NgayTao: [new Date()],
			TenNguoiTao: [tenNguoiLap],
			NgayChuyen: [new Date(), Validators.required],
			phongBan: ['', Validators.required],
			nguoiXacNhan: ['', Validators.required],
			TrangThai: ['', Validators.required],
			LyDo: [''],
		});
		this.masterForm.disable();
		this.changeDetectView();
	}
	getTitle(): string {
		return 'Chi tiết phiếu chuyển kho';
	}
	bindingValueAfterCallAPIDetail() {
		if (this.masterItem.IdCk > 0) {
			/*Get name of người lập phiếu */
			var tenNguoiLap = '';
			this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
			var idUser = '';
			this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
			this.masterForm.controls["SoPhieu"].setValue(this.masterItem.SoPhieu);
			this.masterForm.controls["NgayTao"].setValue(this.masterItem.NgayTao);
			this.masterForm.controls["TenNguoiTao"].setValue(this.masterItem.TenNguoitao);
			this.masterForm.controls["NgayChuyen"].setValue(this.masterItem.NgayChuyen);
			this.masterForm.controls["phongBan"].setValue(this.masterItem.TenPhongBan);
			this.masterForm.controls["nguoiXacNhan"].setValue(this.masterItem.TenDSNguoiXacNhan);
			this.masterForm.controls["TrangThai"].setValue(ChuyenKhoNoiBoMaster.optionsTrangThai.find(option => option.value === this.masterItem.TrangThai).name);
			this.masterForm.controls["LyDo"].setValue(this.masterItem.LyDo);
			/*Add dữ liệu chi tiết*/
			if (this.masterItem.listDetail.length > 0) {
				this.listDetail = this.masterItem.listDetail;
				this.tmpListDetail = [];
				for (let i = 0; i < this.listDetail.length; i++) {
					let tmpElement = new ChuyenKhoNoiBoDetail();
					tmpElement.copy(this.listDetail[i]);
					this.tmpListDetail.push(tmpElement);
				}
				this.tmpListDetail = [...this.tmpListDetail];
			}
		}
	}
	/* -----------------------------------------------------------------------*/
	getListDNCKSelected() {
		var list = this.tmpListDetail.map((x) => {
			var rObj = {};
			rObj["IdDnCk"] = x.IdDnCk;
			rObj["SoPhieuDeNghi"] = x.SoPhieuDeNghi;
			return rObj;
		});
		console.log(list)
		var unique = [];
		list.forEach((x) => {
			if (unique.filter((a) => a.IdDnCk == x["IdDnCk"]).length == 0)
				unique.push(x);
		});
		return unique;
	}
	open_dialog_detail_dnck(__iddn: number) {
		// this.openDialog = true;
		this.deNghiChuyenKhoService.getDeNghiChuyenKhoById(__iddn).subscribe((res) => {
			if (res.status == 1) {
				const dialogRef = this.dialog.open(
					DeNghiChuyenKhoDialogDetailComponent,
					{
						data: {
							data: res.data,
							canEdit: false,
						},
						maxHeight: "90vh",
						width: "90vw",
					}
				);
				dialogRef.afterClosed().subscribe((res) => {
					setTimeout(() => {
						// this.openDialog = false;
					}, 50);
				});
			} else {
				// this.openDialog = false;
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	/*--------- Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng------*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	/* -----------------------------------------------------------------------*/
	/*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
	showErrorInputSL(columnName: string, formGroup: any, name: string) {
		let message = "";
		let controls = formGroup.controls;
		if (controls[columnName].value.length == 0 || this.formatComparenumber(controls[columnName].value) == 0) return name + ' là bắt buộc';
		if (controls[columnName].hasError('maxlength')
			|| (controls[columnName].value.length > 22
				&& (controls[columnName].value.indexOf(',') == 0 || controls[columnName].value.indexOf(',') > 21)))
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		return message;
	}
	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == ',') {
					count += 1;
				}
			}
		}
		else {
			event = "" + event
			for (let i = 0; i < event.length; i++) {
				if (event[i] == ',') {
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	formatComparenumber(number: string) {
		if (number == null || number == undefined || number == '') return 0;
		number = number.toString();
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER_DYNAMIC(item, FunctionPublic.MAX_POINT);
	}
	keyUpInputNumberVND(event) {
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputNumberVND(event, columnName, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }
			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				if (this.f_number(data) < min && event.data && event.data == '0') data = this.f_number((min));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				if (data.length == 4) {
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
			} else {
				controls[columnName].setValue(this.f_number((min)));
			}
		}
	}
	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");
			if (Number(tmpValue) < min) tmpValue = min;
			if (!controls[controlName].invalid) {
				controls[controlName].setValue(
					this.f_number((tmpValue))
				);
			}
			if (tmpValue.indexOf(',') == 0 && tmpValue.length == 1) {
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_number((tmpValue))
			);
		}
		else {
			controls[controlName].setValue(this.f_number((min)));
		}
	}
	changeInputNumberVNDInList(event: any, min: number = 0) {
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }
			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				if (this.f_number(data) < min && event.data && event.data == '0') data = this.f_number(min);
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				if (data.length == 4) {
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
			} else {
				event.target.value = this.f_number((min));
			}
		}
	}
	changeInputOfFormVNDInList(columnName: string, event: any, min: number = 0, item: ChuyenKhoNoiBoDetail) {
		if (event.target.value == "") {
			event.target.value = this.f_number(0);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}
		if (event.target.value.toString() == item[columnName].toString()) {
			event.target.value = this.f_number(item[columnName]);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");
			if (Number(tmpValue) < min) tmpValue = min;
			if (!item[columnName]) {
				item[columnName] = tmpValue.toString();
			}
			if (tmpValue.toString().indexOf(',') == 0 && tmpValue.toString().length == 1) {
				tmpValue = min;
			}
			item[columnName] = tmpValue.toString();
		}
		else {
			item[columnName] = min.toString();
		}
		this.changeDetectView();
	}
	lpad(value, padding) {
		var zeroes = new Array(padding + 1).join("0");
		return (zeroes + value).slice(-padding);
	}
	/* -----------------------------------------------------------------------*/
	/*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
	getFormatDate(v: string = '') {
		if (v != null && v != undefined && v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	/* -----------------------------------------------------------------------*/
	/*---------------------------- Thao tác trên form ------------------------*/
	back() {
		if (this.data && this.data.id)
			this.dialogRef.close();
		else 
			this.router.navigateByUrl('chuyen-kho', { relativeTo: this.activatedRoute });
	}
	/* -----------------------------------------------------------------------*/
	/*------------------------------ Extend Options --------------------------*/
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	scrollToBottom() {
		setTimeout(() => {
			window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
		}, 300);
	}
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.key == "Escape") {
			//this.back();
		}
		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/
	get_date_nhap_kho() {
		var date = new Date(this.masterForm.controls['NgayChuyen'].value);
		return "Ngày " + ("0" + date.getDate().toString()).slice(-2) + "/" + ("0" + (date.getMonth() + 1).toString()).slice(-2) + "/" + date.getFullYear();
	}
	FormatDatetime(datetime) {
		return this.datePipe.transform(datetime, 'dd/MM/yyyy');
	}
	sum_so_luong() {
		// ;
		return this.tmpListDetail.length > 0 ? this.tmpListDetail.map(x => x.SoLuongChuyenGoc).reduce((a, b) => a + b) : 0;
	}
	getLyDo() {
		if (this.masterForm.controls['LyDo'].value) {
			return this.masterForm.controls['LyDo'].value;
		}
		else if (this.tmpListDetail.find(x => x.IdDnCtCk != null)) {
			const filteredList = this.tmpListDetail.filter(x => x.IdDnCtCk !== null);
			// Extract the SoPhieuDeNghi from the filtered list
			const SoPhieuDeNghiList = filteredList.map(x => x.SoPhieuDeNghi);
			return "Theo đề nghị chuyển kho số " + SoPhieuDeNghiList;
		}
	}
	get_date() {
		var date = new Date();
		return "Ngày " + ("0" + date.getDate().toString()).slice(-2) + "/" + ("0" + (date.getMonth() + 1).toString()).slice(-2) + "/" + date.getFullYear();
	}
}